import { makeStyles } from '@material-ui/core';
import loginDialogImage from '../../img/auth/loginDIalogImage.png';
import recoverPasswordDialogImage from '../../img/auth/recoverPasswordDialogImage.png';
import forgotPasswordDialogImage from '../../img/auth/forgotPasswordDialogImage.png';

const useStyles = makeStyles((theme) => ({
  loginDialogImage: {
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${loginDialogImage})`,
  },
  forgotPasswordDialogImage: {
    backgroundImage: `url(${forgotPasswordDialogImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  recoverPasswordDialogImage: {
    backgroundImage: `url(${recoverPasswordDialogImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  loginBlock: {
    display: 'flex',
    flexDirection: 'column',
  },
  forgotPasswordBlock: {
    display: 'flex',
    flexDirection: 'column',
  },
  recoverPasswordBlock: {
    display: 'flex',
    flexDirection: 'column',
  },
  closeButton: {
    color: theme.palette.black.main,
  },
  closeIcon: {
    cursor: 'pointer',
  },
  close: {
    marginBottom: 50,
    padding: '0 15px',
    marginTop: 5,
    textAlign: 'right',
  },
  loginDialogContent: {
    height: 677,
  },
  forgotPasswordDialogContent: {
    height: 606,
  },
  recoverPasswordDialogContent: {
    height: 606,
  },
  root: {
    '& .MuiPaper-root': {
      borderRadius: 28,
    },
    '& .MuiDialogContent-root': {
      paddingLeft: 0,
    },
  },
  loginDialogRoot: {
    '& .MuiDialogContent-root': {
      '@media (min-height: 677px)': {
        overflowY: 'hidden',
      },
    },
  },
  forgotPasswordDialogRoot: {
    '& .MuiDialogContent-root': {
      '@media (min-height: 606px)': {
        overflowY: 'hidden',
      },
    },
  },
  recoverPasswordDialogRoot: {
    '& .MuiDialogContent-root': {
      '@media (min-height: 606px)': {
        overflowY: 'hidden',
      },
    },
  },
}));

export default useStyles;
